import { Component, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { FinanceLedgerService } from '../../../services/finance-ledger/finance-ledger.service';
import { Invoice } from '../../../services/ledger-client/types';
import { FINANCE_TABS, FinanceTab } from '../finance-tabs';

@Component({
    selector: 'app-finance-invoices',
    templateUrl: './finance-invoices.component.html',
    styleUrls: ['./finance-invoices.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FinanceInvoicesComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort!: MatSort;

  tabs: FinanceTab[] = FINANCE_TABS;
  activeTab: FinanceTab = this.tabs.find((tab) => tab.id === 'invoices') || this.tabs[0];
  allColumnNames = ['id', 'invoiceNumber', 'contractId', 'settlementBatchId', 'issueDate', 'dueDate', 'status', 'amount'];
  items = new MatTableDataSource<Invoice>();

  private readonly destroy$ = new Subject<void>();

  constructor(
    private router: Router,
    private snackBar: MatSnackBar,
    private financeLedgerService: FinanceLedgerService,
  ) {}

  ngOnInit(): void {
    this.setActiveTab();
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.destroy$),
    ).subscribe(() => this.setActiveTab());
    this.reloadItems();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private setActiveTab(): void {
    const parsedUrl = this.router.parseUrl(this.router.url);
    const url = parsedUrl.toString().split('?')[0];
    this.activeTab = this.tabs.find((tab) => tab.link === url) || this.tabs[0];
  }

  gotoTab(tab: FinanceTab): void {
    if (this.activeTab?.id === tab.id) {
      return;
    }

    this.router.navigate([tab.link]).then();
    this.activeTab = tab;
  }

  reloadItems(): void {
    this.financeLedgerService.listInvoices().then((invoices) => {
      this.items.data = invoices.sort((a, b) => b.issueDate.localeCompare(a.issueDate));
      this.items.sort = this.sort;
    }).catch((error: unknown) => {
      this.snackBar.open(this.financeLedgerService.getErrorMessage(error, 'Unable to load invoices'), 'Close', { duration: 3000 });
    });
  }
}
